








import {Component, Prop, Vue} from 'vue-property-decorator';
import JdsIcon from "@/design-system/icons/JdsIcon.vue"
import JdsGlyph from "@/design-system/icons/JdsGlyph.vue"
import {ActiveInject} from "@/support/reactive"
@Component({
    components: {JdsGlyph, JdsIcon}
})
export default class JdsListItem extends Vue {
    @Prop({default: null, type: Boolean}) sortable!: boolean|null;
    @ActiveInject({from: 'jds.list-item.sortable', default: false}) inheritSortable!: boolean;

    get isSortable() {
        return this.sortable !== null ? this.sortable : this.inheritSortable;
    }

    // show indent if parent is sortable, even if this item isn't
    get isIndented() {
        return this.inheritSortable;
    }
}
